import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';
import { InvestigationsState } from '../../states/investigations.state';
import { InvestigationMessageEntity } from '../../../domain/entities/investigation-message.entity';

export interface GetInvestigationMessagesQuery { investigationId: string; }
export interface GetInvestigationMessagesResult { messages: InvestigationMessageEntity[]; }

@Injectable({ providedIn: 'root' })
export class GetInvestigationMessagesUseCase {
  private readonly _repository = inject(InvestigationsRepository);
  private readonly _state = inject(InvestigationsState);

  public execute(query: GetInvestigationMessagesQuery): Observable<GetInvestigationMessagesResult> {
    this._state.setLoadingMessages(true);
    this._state.setErrorMessages(null);
    return this._repository.getMessages(query.investigationId).pipe(
      tap((messages) => {
        this._state.setMessages(messages);
        this._state.setLoadingMessages(false);
      }),
      map((messages) => ({ messages })),
      catchError((error) => {
        this._state.setErrorMessages(error.message || 'Failed to get messages');
        this._state.setLoadingMessages(false);
        return throwError(() => error);
      }),
    );
  }
}
